export const ACCESS_TOKEN = "access_token";
export const CLIENT_VERSION = "client_version";
export const PRIVY_TOKEN = "privy:token";

export const REFERRER_ID = "referrer_id";
export const IS_VERIFY_TIKTOK = "is_verify_tiktok";
export const IS_DEPOSIT_ETH = "is_deposit_eth";
export const IS_BUY_FIRST_SHARES = "is_buy_first_shares";

export const IS_REQUIRED_RE_OPEN_PWA = "is_required_re_open_pwa";

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const saveItem = (key: string, value: any) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, value);
  }
};

export const deleteItem = () => {
  return localStorage.clear();
};
